import React from 'react';
import { ReactComponent as RfidIcon } from '../../assets/custom/icons/rfid.svg';
import { ReactComponent as RfidSignalIcon } from '../../assets/custom/icons/rfidSignal.svg';
import './rfidToggleIcon.css';

interface RfidToggleIconProps {
    enabled: boolean;
    inButton?: boolean;
    variant?: 'card' | 'signal';
}

const RfidToggleIcon = ({ enabled, inButton, variant = 'card' }: RfidToggleIconProps) => {
    return (
        <div className={'rfid-toggle-icon' + (enabled ? ' enabled' : ' disabled') + (inButton ? ' in-button' : '')}>
            {variant === 'signal' ? <RfidSignalIcon /> : <RfidIcon />}
        </div>
    );
};

export default RfidToggleIcon;
